import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from "@angular/core";
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

export const recoveryPartnerGuard: CanActivateFn = (route, state): UrlTree | boolean => {
  const authService: AuthService = inject(AuthService);
  const router = inject(Router);
  const account = authService.accountDto();
  if (account?.companyDto?.isRecoverPartner) {
    return true;
  } else {
    return router.createUrlTree(['/']);
  }
};

